import { render, staticRenderFns } from "./indexCggl.vue?vue&type=template&id=cd98a8be&scoped=true"
import script from "./indexCggl.vue?vue&type=script&lang=ts"
export * from "./indexCggl.vue?vue&type=script&lang=ts"
import style0 from "./indexCggl.vue?vue&type=style&index=0&id=cd98a8be&prod&lang=scss&scoped=true"
import style1 from "./indexCggl.vue?vue&type=style&index=1&id=cd98a8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd98a8be",
  null
  
)

export default component.exports